import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import { COMPANY_PHONE_FORMATTED, COMPANY_PHONE_TEL } from "../constants";

const TermsConditionsPage = () => {
  return (
    <div id="conditions">
      <Row className="mt-5 g-0">
        {/* Columna de navegación */}
        <Col xs={12} md={3} className="align-items-center">
          <div className="navigation-links ms-5 mt-5">
            <h3 className="mb-5">Español</h3>
            <a href="#1-spanish" className="nav-link mb-2">
              1. DEFINICIÓN Y ALCANCE
            </a>
            <a href="#2-spanish" className="nav-link mb-2">
              2. SERVICIOS Y LIMITACIÓN DE RESPONSABILIDAD
            </a>
            <a href="#3-spanish" className="nav-link mb-2">
              3. RESPONSABILIDAD DEL CLIENTE
            </a>
            <a href="#4-spanish" className="nav-link mb-2">
              4. VEHÍCULOS INOPERABLES Y MODIFICADOS
            </a>
            <a href="#5-spanish" className="nav-link mb-2">
              5. OBJETOS PERSONALES Y ARTÍCULOS PROHIBIDOS
            </a>
            <a href="#6-spanish" className="nav-link mb-2">
              6. CANCELACIONES Y REEMBOLSOS
            </a>
            <a href="#7-spanish" className="nav-link mb-2">
              7. PAGOS Y CARGOS
            </a>
            <a href="#8-spanish" className="nav-link mb-2">
              8. SEGUROS
            </a>
            <a href="#9-spanish" className="nav-link mb-2">
              9. RECLAMOS POR PÉRDIDA, DAÑO O RETRASO
            </a>
            <a href="#10-spanish" className="nav-link mb-2">
              10. LIMITACIÓN DE RESPONSABILIDAD
            </a>
            <a href="#11-spanish" className="nav-link mb-2">
              11. INDEMNIZACIÓN
            </a>
            <a href="#12-spanish" className="nav-link mb-2">
              12. LEY APLICABLE Y JURISDICCIÓN
            </a>
            <a href="#13-spanish" className="nav-link mb-2">
              13. RELACIÓN CONTRACTUAL
            </a>
            <a href="#14-spanish" className="nav-link mb-2">
              14. DERECHOS DE IMAGEN Y PROMOCIÓN
            </a>
            <a href="#15-spanish" className="nav-link mb-2">
              RESUMEN LEGAL SIMPLIFICADO
            </a>

            <h3 className="mt-5 mb-5">English </h3>
            <a href="#1-english" className="nav-link mb-2">
              1. DEFINITION AND SCOPE
            </a>
            <a href="#2-english" className="nav-link mb-2">
              2. SERVICES AND LIMITATION OF LIABILITY
            </a>
            <a href="#3-english" className="nav-link mb-2">
              3. CUSTOMER RESPONSIBILITIES
            </a>
            <a href="#4-english" className="nav-link mb-2">
              4. INOPERABLE AND MODIFIED VEHICLES
            </a>
            <a href="#5-english" className="nav-link mb-2">
              5. PERSONAL ITEMS AND PROHIBITED ARTICLES
            </a>
            <a href="#6-english" className="nav-link mb-2">
              6. CANCELLATIONS AND REFUNDS
            </a>
            <a href="#7-english" className="nav-link mb-2">
              7. PAYMENTS AND CHARGES
            </a>
            <a href="#8-english" className="nav-link mb-2">
              8. iNSURANCE
            </a>
            <a href="#9-english" className="nav-link mb-2">
              9. CLAIMS FOR LOSS, DAMAGE OR DELAY
            </a>
            <a href="#10-english" className="nav-link mb-2">
              10. LIMITATION OF LIABILITY
            </a>
            <a href="#11-english" className="nav-link mb-2">
              11. INDEMNIFICATION
            </a>
            <a href="#12-english" className="nav-link mb-2">
              12. GOVERNING LAW AND JURISDICTION
            </a>
            <a href="#13-english" className="nav-link mb-2">
              13. CONTRACTUAL RELATIONSHIP
            </a>
            <a href="#14-english" className="nav-link mb-2">
              14. IMAGE AND PROMOTIONAL RIGHTS
            </a>
            <a href="#15-english" className="nav-link mb-2">
              LEGAL SUMMARY
            </a>
          </div>
        </Col>

        {/* Columna de texto con borde izquierdo */}
        <Col
          xs={12}
          md={9}
          className="g-0 px-3"
          style={{ borderLeft: "1px solid #000" }}
        >
          <p className="text-start ms-3">Última actualización: Octubre 2025</p>
          <h1 className="text-start ms-3">Términos y condiciones</h1>
          <p className="align-items-center ms-3">
            Al contratar los servicios de Nomanejes.com de manera escrita,
            telefónica u oral estarán regidos por el siguiente contrato y/o
            Terminos & Condiciones:
          </p>
          <h2 className="align-items-center ms-3 section-anchor" id="1-spanish">
            1. DEFINICIÓN Y ALCANCE
          </h2>
          <p className="align-items-center ms-3">
            GARLAS LLC actúa como agente logístico y corredor autorizado para
            coordinar transporte terrestre y marítimo de vehículos, motocicletas
            y embarcaciones dentro de Estados Unidos, hacia/desde Puerto Rico y
            hacia Centroamérica (Guatemala, Honduras y El Salvador). GARLAS no
            es un transportista directo, sino un intermediario logístico
            (broker) debidamente registrado ante el DOT y FMCSA.
          </p>
          <h2 className="align-items-center ms-3 section-anchor" id="2-spanish">
            2. SERVICIOS Y LIMITACIÓN DE RESPONSABILIDAD
          </h2>
          <p className="align-items-center ms-3">
            GARLAS coordina el transporte con transportistas terrestres y
            marítimos certificados, pero nunca toma posesión del vehículo. La
            responsabilidad directa sobre daños o retrasos recae en el carrier o
            naviera que efectúa el transporte. En rutas marítimas aplican los
            términos del Bill of Lading de la naviera. No se garantizan fechas
            exactas de recogida o entrega.
          </p>
          <h2 className="align-items-center ms-3 section-anchor" id="3-spanish">
            3. RESPONSABILIDAD DEL CLIENTE
          </h2>
          <p className="align-items-center ms-3">
            El cliente debe proporcionar información exacta del vehículo,
            prepararlo adecuadamente, entregar documentación válida, estar
            presente o designar a un representante, inspeccionar y firmar el
            Bill of Lading, y notificar reclamos en 48 horas tras la entrega.
          </p>
          <h2 className="align-items-center ms-3 section-anchor" id="4-spanish">
            4. VEHÍCULOS INOPERABLES Y MODIFICADOS
          </h2>
          <p className="align-items-center ms-3">
            Deben notificarse al momento de la reserva. Vehículos con
            alteraciones o tamaño mayor pueden generar cargos adicionales o ser
            rechazados. Si un vehículo operable se vuelve inoperable, el cliente
            asumirá el recargo de winch o manejo especial.
          </p>
          <h2 className="align-items-center ms-3 section-anchor" id="5-spanish">
            5. OBJETOS PERSONALES Y ARTÍCULOS PROHIBIDOS
          </h2>
          <p className="align-items-center ms-3">
            No se permiten pertenencias personales dentro del vehículo (solo
            accesorios fijos). Se prohíben armas, líquidos inflamables, drogas,
            dinero o documentos. Cualquier objeto no declarado viaja bajo riesgo
            del cliente y puede causar la retención del vehículo por
            autoridades.
          </p>
          <h2 className="align-items-center ms-3 section-anchor" id="6-spanish">
            6. CANCELACIONES Y REEMBOLSOS
          </h2>
          <p className="align-items-center ms-3">
            Cancelaciones antes de asignar un carrier: sin costo. Después de la
            asignación o despacho: tarifa mínima $150 USD. Si el vehículo fue
            cargado o entregado al transportista: aplica cargo adicional. Las
            cancelaciones deben hacerse por correo electrónico a
            info@nomanejes.com.
          </p>
          <h2 className="align-items-center ms-3 section-anchor" id="7-spanish">
            7. PAGOS Y CARGOS
          </h2>
          <p className="align-items-center ms-3">
            Pagos totales antes del embarque o según orden. Pagos C.O.D. deben
            ser en efectivo, money order o cashier’s check. Si el cliente no
            recibe o paga, el vehículo podrá ser almacenado a su costo. Facturas
            vencidas acumulan 1.5% de interés mensual.
          </p>
          <h2 className="align-items-center ms-3 section-anchor" id="8-spanish">
            8. SEGUROS
          </h2>
          <p className="align-items-center ms-3">
            Doméstico USA: seguro incluido (FMCSA). | USA«PR: opcional $100
            (25k) / $200 (50k) con deducible $1,000. | USA®Centroamérica: no
            disponible. GARLAS recomienda seguro marítimo opcional para autos de
            valor superior a $15,000 USD.
          </p>
          <h2 className="align-items-center ms-3 section-anchor" id="9-spanish">
            9. RECLAMOS POR PÉRDIDA, DAÑO O RETRASO
          </h2>
          <p className="align-items-center ms-3">
            GARLAS no es responsable por daños o pérdidas. Reclamos deben
            presentarse directamente al carrier o naviera conforme a la ley
            (Carmack Amendment o Carriage of Goods by Sea Act). GARLAS asistirá
            con la información necesaria.
          </p>
          <h2
            className="align-items-center ms-3 section-anchor"
            id="10-spanish"
          >
            10. LIMITACIÓN DE RESPONSABILIDAD
          </h2>
          <p className="align-items-center ms-3">
            La responsabilidad máxima de GARLAS por cualquier reclamo no
            excederá el valor pagado por sus servicios de intermediación. No
            garantiza ganancias, tiempos de entrega ni condiciones futuras del
            mercado.
          </p>
          <h2
            className="align-items-center ms-3 section-anchor"
            id="11-spanish"
          >
            11. INDEMNIZACIÓN
          </h2>
          <p className="align-items-center ms-3">
            El cliente indemniza a GARLAS ante cualquier reclamo o pérdida
            derivada de información falsa, violaciones de ley o daños causados
            por artículos no autorizados.
          </p>
          <h2
            className="align-items-center ms-3 section-anchor"
            id="12-spanish"
          >
            12. LEY APLICABLE Y JURISDICCIÓN
          </h2>
          <p className="align-items-center ms-3">
            Este acuerdo se rige por las leyes del Estado de Florida. Las
            disputas se resolverán en los tribunales del Condado de Miami-Dade,
            salvo arbitraje acordado. En Puerto Rico o Centroamérica aplican
            leyes marítimas locales.
          </p>
          <h2
            className="align-items-center ms-3 section-anchor"
            id="13-spanish"
          >
            13. RELACIÓN CONTRACTUAL
          </h2>
          <p className="align-items-center ms-3">
            Nada constituye sociedad o empleo entre las partes. GARLAS y el
            cliente actúan como entidades independientes. Estos términos
            reemplazan cualquier acuerdo previo.
          </p>
          <h2
            className="align-items-center ms-3 section-anchor"
            id="14-spanish"
          >
            14. DERECHOS DE IMAGEN Y PROMOCIÓN
          </h2>
          <p className="align-items-center ms-3">
            GARLAS podrá usar el nombre o logo del cliente como referencia
            comercial, salvo que el cliente lo rechace por correo a
            info@nomanejes.com.
          </p>
          <h2
            className="align-items-center ms-3 section-anchor"
            id="15-spanish"
          >
            RESUMEN LEGAL SIMPLIFICADO
          </h2>
          <p className="align-items-center ms-3">
            GARLAS actúa como intermediario autorizado, no transportista. Los
            tiempos son estimados, las cancelaciones generan cargos
            administrativos, el seguro marítimo es opcional, y las reclamaciones
            se presentan directamente al carrier o naviera.
          </p>

          <p className="text-start ms-3">Last updated: October 2025</p>
          <h1 className="text-start ms-3">Terms and Conditions</h1>
          <p className="align-items-center ms-3">
            By contracting the services of Prautotransport.com in written,
            telephone or oral manner will be governed by the following agreement
            and/or Terms & Conditions.
          </p>
          <h2 className="align-items-center ms-3 section-anchor" id="1-english">
            1. DEFINITION AND SCOPE{" "}
          </h2>
          <p className="align-items-center ms-3">
            GARLAS LLC acts as an authorized logistics agent and broker to
            coordinate land and ocean transportation of vehicles, motorcycles,
            boats, and vessels within the United States, to and from Puerto
            Rico, and to Central America (Guatemala, Honduras, and El Salvador).
            GARLAS is not a direct carrier but a licensed logistics intermediary
            (broker) registered with the DOT and FMCSA.
          </p>
          <h2 className="align-items-center ms-3 section-anchor" id="2-english">
            2. SERVICES AND LIMITATION OF LIABILITY
          </h2>
          <p className="align-items-center ms-3">
            GARLAS coordinates transport through certified land and ocean
            carriers but never takes physical possession of the vehicle.
            Responsibility for loss or delay lies with the carrier or shipping
            line executing the transport. Ocean shipments are also subject to
            the carrier’s Bill of Lading terms. Pickup and delivery dates are
            estimated and not guaranteed.
          </p>
          <h2 className="align-items-center ms-3 section-anchor" id="3-english">
            3. CUSTOMER RESPONSIBILITIES
          </h2>
          <p className="align-items-center ms-3">
            The customer must provide accurate vehicle information, prepare the
            vehicle properly, submit valid documentation, be present or appoint
            a representative at pickup and delivery, inspect and sign the Bill
            of Lading, and report any claims within 48 hours after delivery.
          </p>
          <h2 className="align-items-center ms-3 section-anchor" id="4-english">
            4. INOPERABLE AND MODIFIED VEHICLES
          </h2>
          <p className="align-items-center ms-3">
            Vehicles that are inoperable or modified must be disclosed at the
            time of booking. Oversized or altered vehicles may incur extra
            charges or be rejected. If a running vehicle becomes inoperable
            during handling or transport, the customer will be responsible for
            additional winch or special handling fees.
          </p>
          <h2 className="align-items-center ms-3 section-anchor" id="5-english">
            5. PERSONAL ITEMS AND PROHIBITED ARTICLES
          </h2>
          <p className="align-items-center ms-3">
            No personal items are allowed inside the vehicle (only
            factory-installed accessories). Firearms, flammable liquids, drugs,
            money, and documents are prohibited. Any undeclared items travel at
            the customer’s sole risk and may cause the vehicle to be held by
            port or customs authorities.
          </p>
          <h2 className="align-items-center ms-3 section-anchor" id="6-english">
            6. CANCELLATIONS AND REFUNDS
          </h2>
          <p className="align-items-center ms-3">
            Cancellations before carrier assignment: no fee. After assignment or
            dispatch: $150 USD minimum administrative fee. If the vehicle has
            been loaded or handed to the carrier, additional charges may apply.
            Cancellations must be submitted via email to
            info@nomanejes.com. Phone or chat cancellations will not be
            accepted.
          </p>
          <h2 className="align-items-center ms-3 section-anchor" id="7-english">
            7. PAYMENTS AND CHARGES
          </h2>
          <p className="align-items-center ms-3">
            All payments must be completed in full prior to shipment or as
            stated on the order confirmation. C.O.D. payments must be made in
            cash, money order, or cashier’s check—personal checks or cards are
            not accepted. Vehicles may be stored at the customer’s expense if
            delivery is refused or payment is incomplete. Late invoices accrue
            1.5% monthly interest.
          </p>
          <h2 className="align-items-center ms-3 section-anchor" id="8-english">
            8. INSURANCE
          </h2>
          <p className="align-items-center ms-3">
            Domestic USA: insurance included (FMCSA). | USA«Puerto Rico:
            optional $100 (25k) / $200 (50k) with $1,000 deductible. |
            USA®Central America: not available. GARLAS recommends optional
            maritime insurance for vehicles valued over $15,000 USD.
          </p>
          <h2 className="align-items-center ms-3 section-anchor" id="9-english">
            9. CLAIMS FOR LOSS, DAMAGE OR DELAY
          </h2>
          <p className="align-items-center ms-3">
            GARLAS is not liable for damage or loss. Claims must be filed
            directly with the carrier or shipping line in accordance with
            applicable laws (Carmack Amendment or Carriage of Goods by Sea Act).
            GARLAS will assist in providing carrier details upon request.
          </p>
          <h2
            className="align-items-center ms-3 section-anchor"
            id="10-english"
          >
            10. LIMITATION OF LIABILITY
          </h2>
          <p className="align-items-center ms-3">
            The maximum liability of GARLAS for any claim shall not exceed the
            service fees paid for brokerage services. GARLAS does not guarantee
            delivery times, profit, or future market conditions.
          </p>
          <h2
            className="align-items-center ms-3 section-anchor"
            id="11-english"
          >
            11. INDEMNIFICATION
          </h2>
          <p className="align-items-center ms-3">
            The customer agrees to indemnify and hold GARLAS harmless from any
            claims, fines, or losses arising from false information, legal
            violations, or damages caused by unauthorized or unreported items.
          </p>
          <h2
            className="align-items-center ms-3 section-anchor"
            id="12-english"
          >
            12. GOVERNING LAW AND JURISDICTION
          </h2>
          <p className="align-items-center ms-3">
            This agreement is governed by the laws of the State of Florida, USA.
            Any disputes shall be resolved in the courts of Miami-Dade County
            unless arbitration is mutually agreed. For Puerto Rico or Central
            America operations, local maritime laws apply.
          </p>
          <h2
            className="align-items-center ms-3 section-anchor"
            id="13-english"
          >
            13. CONTRACTUAL RELATIONSHIP
          </h2>
          <p className="align-items-center ms-3">
            Nothing in this agreement constitutes partnership, employment, or
            agency. GARLAS and the customer act as independent entities. These
            Terms supersede all prior agreements.
          </p>
          <h2
            className="align-items-center ms-3 section-anchor"
            id="14-english"
          >
            14. IMAGE AND PROMOTIONAL RIGHTS
          </h2>
          <p className="align-items-center ms-3">
            GARLAS may use the client’s name or logo as a commercial reference
            unless the client opts out by emailing info@nomanejes.com.
          </p>
          <h2
            className="align-items-center ms-3 section-anchor"
            id="15-english"
          >
            LEGAL SUMMARY
          </h2>
          <p className="align-items-center ms-3">
            GARLAS LLC acts as a licensed intermediary, not a carrier. Delivery
            times are estimates, cancellations generate administrative fees,
            maritime insurance is optional, and claims must be filed directly
            with the carrier or shipping line.
          </p>

          <div style={{ backgroundColor: "#EEF4D2" }} className="text-center">
            <h3 className="mb-5">¿Necesitas más información?</h3>

            <Button
              variant="outline-light"
              className="nav-button mb-5"
              style={{ justifyContent: "center", width: "75%" }}
              href={COMPANY_PHONE_TEL}
            >
              LLamar al {COMPANY_PHONE_FORMATTED}
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default TermsConditionsPage;
